<template>
    <b-modal
            no-enforce-focus
            ref="pageModal"
            :id="id"
            size="xl"
            :title="formData.label ? formData.label : 'New Page'">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.pageModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="busy" variant="primary" v-on:click.native="onSubmit()">
                SAVE
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col>
                    <b-form>
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col md="4">
                                <label for="name">Name</label>
                                <b-form-input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="Name"
                                        v-model.trim="formData.name"
                                        v-validate="'required'"
                                        :state="validateState('name')"
                                ></b-form-input>
                            </b-col>
                            <b-col md="4">
                                <label for="label">Label</label>
                                <b-form-input
                                        id="label"
                                        name="label"
                                        type="text"
                                        placeholder="Label"
                                        v-model.trim="formData.label"
                                        v-validate="'required'"
                                        :state="validateState('label')"
                                ></b-form-input>
                            </b-col>
                            <b-col md="4">
                                <label for="templateSelect">Template</label>
                                <b-form-select :disabled="!!(formData.id)" id="templateSelect" v-model="selectedTemplate"
                                               :options="templateOptions"></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <form-generator :schema="schema" :value="formData">
                                </form-generator>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>


    import TemplateApi from "@shared/_api/cms/template";
    import ContentAPI from "@shared/_api/cms/content";
    import FormGenerator from "../form/FormGenerator";

    function initialData() {
        return {
            busy: false,
            submitError: null,
            selectedTemplate: null,
            templateList: [],
            schema: {},
            formData: {
                id: null,
                name: null,
                label: null,
                contentDataSet: [],
            }
        }
    }

    export default {
        name: 'page-modal',
        props: {
            id: String
        },
        data() {
            return initialData();
        },
        components: {
            "form-generator": FormGenerator
        },
        methods: {
            manageEntity(entity) {
                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                    Object.assign(this.$data.formData, entity);
                    if (entity && entity.template) {
                        this.$data.selectedTemplate = entity.template.id;
                        this.$data.schema = entity.template.templateFields;
                    }
                    TemplateApi.get().then((templateList) => {
                        this.templateList = templateList;
                    }).catch(error => {
                        this.apiError = error;
                    }).finally(() => {
                        this.busy = false;
                    });
                });
            },
            onSubmit() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.busy = true;

                        let apiFunction = this.formData.id ? ContentAPI.update : ContentAPI.insert;

                        apiFunction(this.formData).then(() => {
                            this.$nextTick(() => {
                                this.$emit('saved');
                                this.$refs.pageModal.hide();
                            })
                        }).catch(() => {
                            this.submitError = "An error occured.";
                        }).finally(() => {
                            this.busy = false;
                        });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            }
        },
        computed: {
            templateOptions() {
                return this.templateList.map(template => {
                    return {
                        value: template.id,
                        text: template.label
                    }
                })
            },
        },
        watch: {
            selectedTemplate: function (newSelectedTemplateId) {
                let selectedTemplate = this.templateList.find(template => template.id === newSelectedTemplateId);

                if (selectedTemplate && !this.formData.id) {
                    this.schema = Object.assign({}, selectedTemplate.templateFields);

                    this.formData.template = selectedTemplate;

                    selectedTemplate.templateFields.forEach(template => {
                        this.formData.contentDataSet[template.name] = {
                            value: '',
                            templateField: template
                        };
                    });
                }
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
